// Modules
import cn from 'classnames';

// Types
import type { TBreadcrumbProps, TBreadcrumbSeparator } from './Breadcrumb.type';

// Styles
import styles from './styles.module.scss';

// Components
import { Fragment } from 'react';

// Helpers
import { isValidElement } from 'react'
import { isEmpty } from '../../helpers/common';

// Constants
import { BREADCRUMB_DEFAULT_PROPS, BREADCRUMB_SEPARATOR } from './Breadcrumb.constant';

const getSeparator = (separator: TBreadcrumbSeparator) => {
	if (separator === BREADCRUMB_SEPARATOR.chevron) {
		return '>';
	}
	else {
		return '/';
	}
}

const Breadcrumb = (props: TBreadcrumbProps) => {
	const {
		className,
		itemClassName,
		items = BREADCRUMB_DEFAULT_PROPS.items,
		separator = BREADCRUMB_DEFAULT_PROPS.separator,
		separatorClassName,
		...restProps
	} = props;

	const breadcrumbCN = cn(styles.legion_breadcrumb, className);
	const separatorCN = cn(styles.breadcrumb_separator, separatorClassName);
	const separatorValue = isValidElement(separator) ? separator : getSeparator(separator as TBreadcrumbSeparator);

	return (
		<div className={breadcrumbCN} {...restProps}>
			{!isEmpty(items) && items.map((item, index) => {
				const lastItem = index === items.length - 1;
				const breadcrumbItemCN = cn(styles.breadcrumb_item, itemClassName, {
					[styles.active]: lastItem
				})

				return (
					<Fragment key={index}>
						{index !== 0 && (
							<span className={separatorCN}>
								{separatorValue}
							</span>
						)}
						{lastItem ? (
							<span key={index} className={breadcrumbItemCN}>
								{item}
							</span>
						) : (
							<span key={index} className={breadcrumbItemCN}>
								{item}
							</span>
						)}
					</Fragment>
				)
			})}
		</div>
	);
}

export default Breadcrumb;
